import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OwnersService {
    /**
     * Get All Owners
     * @param searchTerm
     * @param limit
     * @param offset
     * @returns LimitOffsetPage_OwnerModel_ Successful Response
     * @throws ApiError
     */
    static getAllOwnersOwnersGet(searchTerm, limit = 50, offset) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/owners',
            query: {
                'search_term': searchTerm,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Owner
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static createOwnerOwnersPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/owners',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Download Owners
     * @returns any Successful Response
     * @throws ApiError
     */
    static bulkDownloadOwnersOwnersBulkDownloadGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/owners/bulk/download',
        });
    }
    /**
     * Bulk Upload Owners
     * Bulk upload endpoint for owners. It accepts a csv file with the following columns:
     * id, name, email, phone, address, lat, long, chain_id
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    static bulkUploadOwnersOwnersBulkUploadPost(formData) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/owners/bulk/upload',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Owner
     * @param ownerId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static updateOwnerOwnersOwnerIdPut(ownerId, requestBody) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/owners/{owner_id}',
            path: {
                'owner_id': ownerId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Owner
     * @param ownerId
     * @returns any Successful Response
     * @throws ApiError
     */
    static deleteOwnerOwnersOwnerIdDelete(ownerId) {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/owners/{owner_id}',
            path: {
                'owner_id': ownerId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Map Bnames Owner
     * This endpoint is used to remap all bnames to a owner.
     * @param ownerId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static mapBnamesOwnerOwnersMapOwnerIdPut(ownerId, requestBody) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/owners/map/{owner_id}',
            path: {
                'owner_id': ownerId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
